import DeleteAgent from './DeleteAgent';
import DisableAgent from './DisableAgent';

type ConfirmModalSubComponents = {
  DeleteAgent: typeof DeleteAgent;
  DisableAgent: typeof DisableAgent;
};

const ConfirmModal: ConfirmModalSubComponents = () => null;

ConfirmModal.DeleteAgent = DeleteAgent;
ConfirmModal.DisableAgent = DisableAgent;

export default ConfirmModal;
